var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { avatarAnatomy } from "@chakra-ui/anatomy";
import { cgx } from "@springcare/dsm";
import { isVerdantColorScheme } from "../../utils/guards";
export var avatarTheme = {
    parts: avatarAnatomy.keys,
    variants: {
        "v-medium-emphasis": function (_a) {
            var colorScheme = _a.colorScheme;
            if (isVerdantColorScheme(colorScheme))
                return {
                    container: {
                        background: "".concat(colorScheme, "-subtle"),
                        color: "".concat(colorScheme, "-on-subtle"),
                    },
                };
            return {
                container: {
                    background: "accent-subtle",
                    color: "accent-on-subtle",
                },
            };
        },
    },
    sizes: {
        "v-md": {
            container: __assign(__assign({}, cgx.textStyles["data-medium"]), { width: "24px", height: "24px" }),
        },
        "v-lg": {
            container: __assign(__assign({}, cgx.textStyles["body-medium-strong"]), { width: "40px", height: "40px" }),
        },
        "v-xl": {
            container: __assign(__assign({}, cgx.textStyles["body-medium-strong"]), { width: "48px", height: "48px" }),
        },
        "v-2xl": {
            container: __assign(__assign({}, cgx.textStyles["body-medium-strong"]), { width: "56px", height: "56px" }),
        },
    },
    defaultProps: {
        size: "v-md",
        variant: "v-medium-emphasis",
    },
};
